import { ErrorBoundary } from '../../shared/components'
import AppHeader from '../../shared/components/AppHeader'

export default function TrendsPage() {
  return (
    <ErrorBoundary>
      <AppHeader />
      <div className="container">
        <header>
          <h1>Trends</h1>
          <p>View your net worth trends over time</p>
        </header>
        
        <main>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2>Trend Analysis</h2>
            <p className="text-muted">Trends functionality will be implemented in future tasks</p>
          </div>
        </main>
      </div>
    </ErrorBoundary>
  )
}